import { render, staticRenderFns } from "./adItem.vue?vue&type=template&id=096f94a0"
import script from "./adItem.vue?vue&type=script&lang=js"
export * from "./adItem.vue?vue&type=script&lang=js"
import style0 from "./adItem.vue?vue&type=style&index=0&id=096f94a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports